import React from "react";
import { useNavigate } from "react-router-dom";

import SignupTypePage from "../../components/auth/SignupTypePage";

const SignupTypeRoute = () => {
  const navigate = useNavigate();

  return (
    <SignupTypePage
      onChooseAthlete={() => navigate("/signup/athlete")}
      onChooseScout={() => navigate("/signup/scout")}
      onGoToLogin={() => navigate("/login")}
    />
  );
};

export default SignupTypeRoute;
